import * as IconSet from '.';
export default IconSet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/IconSet.js
// module id = 2001
// module chunks = 12